<div class="control" [class.disabled]="disabled">
  <i-tabler name="circle-minus" (click)="$event.stopPropagation();decrement()"></i-tabler>
  <span>{{ disabled ? 0 : number}}</span>
  <i-tabler name="circle-plus" (click)="$event.stopPropagation();increment()"></i-tabler>
</div>
